export const klarnaLocales = ['de', 'fr', 'se', 'no', 'dk', 'nl'];
